export const bannersCompare = {
    init: function () {
        const sliders = document.querySelectorAll('.slider-compare');
        if(!sliders) return;

        sliders.forEach(el => {
            const slides = el.querySelectorAll('.slider-compare__slide');
            this.countNumberOfCircles(slides);
            this.setSliderHeight(slides);
            this.bannerAnimation(el);
        })
    },
    countNumberOfCircles: function (slides) {
        slides.forEach(el => {
            const circles = el.querySelectorAll('.slider-circle');
            const circlesWrapper = el.querySelector('.slider-compare__content');
            const numberOfCircles = circles.length;
            this.changePositionOfCircles(numberOfCircles, circlesWrapper);
        })
    },
    changePositionOfCircles: function (numberOfCircles, circlesWrapper) {
        if (numberOfCircles < 4) return;
        circlesWrapper.style.justifyContent = "flex-start";
    },
    setSliderHeight: function (slides) {
        slides.forEach(el => {
            let maxHeight = 0;
            if (maxHeight < el.offsetHeight) maxHeight = el.offsetHeight;
        })
    },
    bannerAnimation: function (slidesContainer) {
        const secondSlide = slidesContainer.querySelector('.slider-compare__slide--second');
        const firstSlide = slidesContainer.querySelector('.slider-compare__slide--first');
        const buttonCompareFirst = slidesContainer.querySelector('.compareButtonFirst');
        const buttonCompareSecond = slidesContainer.querySelector('.compareButtonSecond');
        const buttonOverlay = slidesContainer.querySelector('.slider-compare__button-overlay');

        const options = {
            firstSlide: firstSlide,
            secondSlide: secondSlide,
            buttonCompareFirst: buttonCompareFirst,
            buttonCompareSecond: buttonCompareSecond,
            buttonOverlay: buttonOverlay
        }

        buttonCompareFirst.addEventListener('click', _ => {
            if(buttonCompareFirst.classList.contains('active')) return;
            this.animateToLeft(options);
        });

        buttonCompareSecond.addEventListener('click', _ => {
            if(buttonCompareSecond.classList.contains('active')) return;
            this.animateToRight(options);
        });
    },
    animateToLeft: function (options) {
        options.firstSlide.classList.remove('active');
        options.buttonCompareSecond.classList.remove('active');
        options.buttonOverlay.classList.remove('toRightActive');
        options.buttonOverlay.classList.add('toLeftActive');
        options.buttonCompareFirst.classList.add('active');
        options.secondSlide.classList.add('active');
        options.firstSlide.classList.add('unActive');
        // options.secondSlide.style.position = "relative";
        // options.firstSlide.style.position = "absolute";
    },
    animateToRight: function (options) {
        options.secondSlide.classList.remove('active');
        options.buttonCompareFirst.classList.remove('active');;
        options.firstSlide.classList.remove('unActive');
        options.buttonOverlay.classList.remove('toLeftActive');
        options.buttonOverlay.classList.add('toRightActive');
        options.firstSlide.classList.add('active');
        options.buttonCompareSecond.classList.add('active');
        // options.secondSlide.style.position = "absolute";
        // options.firstSlide.style.position = "relative";
    }
}